

import { defineComponent } from 'vue';

import { main } from '@popperjs/core';
import moment from 'moment';

export default defineComponent({
  name: "categories-card",
  props: {
    cardTitle: {
        type: String,
        default: "",
      },
    atrasados: {
        type: Array,
        default: () => {
          {};
        },
      }
    
  },
  methods: {

      gotoPedido(pedido:any){
        this.$router.push(`/pedidos/${pedido.id_pedido}`);
      },
  },
  setup(props:any) {
      
      const fDate = (date:any) => {
        return moment(date).format('DD/MM/YYYY HH:mm:ss');
      }


      const getIncio = (p:any) => {

        const inicio = new Date(p.data_rota_inicio);

        const prazoPrevisto = new Date(
					inicio.getTime() + (p.tempo_estimado_minutos_eta * 60 * 1000)
				);

        return moment(prazoPrevisto).format('DD/MM/YYYY HH:mm');
      }

      return {
        fDate,
        getIncio
      };
  }
});
